import { DEFAULT_MAX_NUM_OPTIONS_PER_VARIANT, MAX_NUM_OPTIONS_PER_VARIANT, MENTION_VARIANT_ORDER, } from '#pplx/frontend/components/form/lexical/plugins/MentionsPluginShared.js';
function getMentionMatchScore(option, query) {
    if (!query)
        return 0;
    if (option.isAlwaysVisible)
        return 1;
    const labelLower = option.label.toLowerCase();
    const hasLeadingSlashVariant = option.variant === 'shortcut' || option.variant === 'slash-command';
    const matchableLabel = hasLeadingSlashVariant && labelLower.startsWith('/') ? labelLower.slice(1) : labelLower;
    const matchableTexts = [
        matchableLabel,
        ...(option.searchAliases ?? []).map((alias) => alias.toLowerCase()),
        ...(option.variant === 'skills' ? [] : [option.url?.toLowerCase()]),
    ];
    const matchesExactly = (text) => text === query;
    const matchesPrefix = (text) => text?.startsWith(query);
    const matchesSubstring = (text) => text?.includes(query);
    if (matchableTexts.some(matchesExactly))
        return 3;
    if (matchableTexts.some(matchesPrefix))
        return 2;
    if (matchableTexts.some(matchesSubstring))
        return 1;
    return 0;
}
export function filterMentionTypeaheadOptions({ options, queryString, }) {
    const query = queryString?.toLocaleLowerCase().trim();
    const filteredAndSortedOptions = options
        .map((option) => ({
        option,
        matchScore: getMentionMatchScore(option, query),
    }))
        .filter(({ matchScore }) => matchScore > 0 || !query)
        .sort((a, b) => {
        const variantOrder = (MENTION_VARIANT_ORDER[a.option.variant] ?? Number.MAX_SAFE_INTEGER) -
            (MENTION_VARIANT_ORDER[b.option.variant] ?? Number.MAX_SAFE_INTEGER);
        if (variantOrder !== 0)
            return variantOrder;
        return b.matchScore - a.matchScore;
    })
        .map(({ option }) => option);
    let currentVariant = '';
    let currentVariantCount = 0;
    const items = [];
    filteredAndSortedOptions.forEach((option) => {
        if (option.variant !== currentVariant) {
            currentVariant = option.variant;
            currentVariantCount = 0;
        }
        const maxOptionsCount = MAX_NUM_OPTIONS_PER_VARIANT[currentVariant] ?? DEFAULT_MAX_NUM_OPTIONS_PER_VARIANT;
        if (currentVariantCount >= maxOptionsCount && !option.isAlwaysVisible) {
            return;
        }
        items.push(option);
        currentVariantCount += 1;
    });
    return items;
}
//# sourceMappingURL=MentionsPluginSupport.js.map